var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc"},[_c('Nav'),(_vm.$store.getters.GetPath == 'Home')?_c('Home',{staticClass:"pc-view"}):_vm._e(),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }